/* eslint-disable @typescript-eslint/no-explicit-any */
import { types } from 'util'
import { uniq } from 'lodash'

export function getIds(obj: any, idProps: Array<string> = ['_ref', '_id']): string[] {
  if (!obj || typeof obj !== 'object') return []
  if (types.isDate(obj) || types.isRegExp(obj)) return []
  if (Array.isArray(obj)) {
    return obj.map((val) => getIds(val, idProps)).reduce((res, ids) => [...res, ...ids], [])
  }

  return Object.keys(obj)
    .reduce((res, key) => {
      if (idProps.indexOf(key) > -1) {
        return [...res, obj[key]]
      }

      return [...res, ...getIds(obj[key], idProps)]
    }, [] as string[])
    .map(String)
}

export const getSortedUniqueIds = (obj: any, idProps?: string[]) =>
  uniq(getIds(obj, idProps)).sort()
